import Vue from 'vue';
import Rollbar from 'vue-rollbar';

const isProduction = process.env.VUE_APP_ENV === 'production';

Vue.use(Rollbar, {
  accessToken: process.env.VUE_APP_ROLLBAR_TOKEN,
  hostSafeList: ['motionelements.com', 'cloudfront.net'],
  captureUncaught: true,
  captureUnhandledRejections: true,
  verbose: !isProduction,
  enabled: true, //! ['development'].includes(process.env.VUE_APP_ENV),
  environment: process.env.VUE_APP_ENV,
});

function vueErrorContext(vm, info) {
  if (!vm) {
    return {
      vueInfo: info,
      componentName: undefined,
      componentFile: undefined,
      route: undefined,
      // ssr: process.server,
    };
  }
  const route = vm?.$route
    || vm?.$nuxt?.context?.route
    || (typeof window !== 'undefined' && window.$nuxt?.$route);
  const fullPath = route && (route.fullPath || route.path);
  return {
    vueInfo: info,
    // eslint-disable-next-line no-underscore-dangle
    componentName: vm.$options.name || vm.$options._componentTag,
    // eslint-disable-next-line no-underscore-dangle
    componentFile: vm.$options.__file,
    route: fullPath,
    // ssr: process.server,
  };
}

Vue.config.errorHandler = function (err, vm, info) {
  const extras = vueErrorContext(vm, info);
  const rollbar = vm?.$rollbar || Vue.prototype.$rollbar;
  if (!isProduction) console.error(err, info);
  // eslint-disable-next-line no-unused-expressions
  rollbar?.error(err, extras);
};
